import script from "./checkAbilitaddPost.vue?vue&type=script&lang=js"
export * from "./checkAbilitaddPost.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__